export const isUrl = (value) => {
  const regex = /^(https?):\/\/[^\s$.?#].[^\s]*$/
  return regex.test(value)
}
